import React from 'react'
import { HeightTruncate } from '@mobi/component-library/Misc/HeightTruncate'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon, BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import type { Ticket as TicketType } from '@core/Areas/AccountActivity/types'
import { getTicketLayoutType } from '@core/Areas/AccountActivity/Components/Ticket/helpers'

export const HeightTruncateWrapper: React.FC<
  {
    children: React.ReactNode
    onChangeCallback: (expanded: boolean) => void
    shouldEnableHeightTruncate?: boolean
  } & ({ coupon: Coupon; ticket?: never } | { ticket: Ticket; coupon?: never })
> = ({ children, ticket, coupon, onChangeCallback, shouldEnableHeightTruncate = true }) => {
  if (!shouldEnableHeightTruncate) return children

  const shouldEnable = ticket
    ? shouldEnableHeightTruncateRacing(ticket)
    : shouldEnableHeightTruncateSport(coupon)

  if (!shouldEnable) return children

  return (
    <HeightTruncate maxHeightRem={30} onChangeCallback={onChangeCallback}>
      {children}
    </HeightTruncate>
  )
}

// =============
// Local Helpers
// =============

function shouldEnableHeightTruncateRacing(ticket: BetLoopShareTicket): boolean {
  const layoutType = getTicketLayoutType(ticket)
  if (layoutType === 'multi' && ticket.legs.length > 2) return true
  if (layoutType === 'single-multiple') {
    const acceptorCount = ticket.legs[0].selections.reduce(
      (count, selection) => selection.selectionDetails[0].acceptorDetails.length + count,
      0
    )
    return acceptorCount > 6
  }

  return false
}

function shouldEnableHeightTruncateSport(coupon: BetLoopKambiShareCoupon): boolean {
  if (coupon.bets[0]?.couponRowIndexes.length > 2) {
    return true
  }
  if (coupon.betOffers.length > 4) {
    // sgm
    return true
  }
  return false
}

// =====
// Types
// =====

type Coupon = KambiHistoryCoupon | BetLoopKambiShareCoupon
type Ticket = TicketType | BetLoopShareTicket
